export default __webpack_public_path__ + "static/media/118-meditate-daydream.b890118e.jpeg";